module.exports = {"441426101":"石正镇","441426104":"八尺镇","441426105":"差干镇","441426107":"河头镇","441426108":"中行镇","441426109":"上举镇","441426110":"泗水镇","441426114":"长田镇","441426115":"热柘镇","441426117":"东石镇","441426118":"仁居镇","441426119":"大柘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441426.json
// module id = 1855
// module chunks = 0